export const environment = {
  production: true,
  hmr: false,
  allowFakeAuth: false,
  warn: false,
  timeBetweenInstallPrompts: 604800000, // 1 week
  enforceMaintenanceMode: true,
  userIdleTimeoutSeconds: 1200, // 20 minutes
  cdnMutualFundAccountFormsPath: "/digitalforms/js/mutualfundaccountforms.js",
  cdnMutualFundAccountDistributionFormsPath:
    "/digitalforms/js/mutualfundaccountdistributionforms.js",
  cdnMutualFundAccountPdfPath: "/digitalforms/pdf",
  cdnMutualFundAccountHtmlPath: "/digitalforms/html",
};
